import { Injectable } from '@angular/core';
import { ApiCallService } from 'src/app/modules/core/services/api/api-call.service';
import { CommunicationService } from 'src/app/services/communication';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ChimneyHandlerService {
  private baseUrl: string;

  constructor(
    private apiCallService: ApiCallService,
    private communicationService: CommunicationService,
    private urlBuilderService: UrlBuilderService,
  ) {
    this.baseUrl = this.urlBuilderService.serverBasePath;
  }

  public getProductionByChimney(params: any): Promise<any> {
    const base = `Production/GetTotalProductionChimneyByStreet`;
    return this.apiCallService.get(base, params);
  }

  /**
   * Get data detail Modal Chimney
   */
  public getModalChimney(params: any): Promise<any> {
    const url = `${this.baseUrl}/Production/GetDetailProductionChimney`;
    return this.communicationService.get(url, params).toPromise();
  }
}
